import { FC, useContext, useEffect, useState } from 'react'
import { Alert, AlertTitle } from '@material-ui/lab'
import { Link, Snackbar, Typography } from '@material-ui/core'
import { observer } from 'mobx-react'
import globalStore, { GlobalStoreContext } from '../stores/GlobalStore'

const WarningSnackbar: FC<unknown> = () => {
  const [open, setOpen] = useState(false)
  const { globalAppWarning } = useContext(GlobalStoreContext)

  useEffect(() => {
    setOpen(globalAppWarning !== undefined)
  }, [globalAppWarning])

  useEffect(() => {
    if (!open) {
      globalStore.setGlobalAppWarning(undefined)
    }
  }, [open])

  const handleClose = (_event: unknown, reason?: string) => {
    // Ignore clickaway so clicking outside doesn't dismiss it
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={10000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={() => setOpen(false)} severity='warning' icon={null}>
        <AlertTitle>{globalStore.globalAppWarning?.warningTitle}</AlertTitle>
        <Typography>{globalStore.globalAppWarning?.warningSummary}</Typography>
        <Link href={`${globalStore.globalAppWarning?.warningLink}`} target='_blank'>
          {globalStore.globalAppWarning?.warningLink}
        </Link>
      </Alert>
    </Snackbar>
  )
}

export default observer(WarningSnackbar)
